// PulseMark.js — the FerrumIQ product mark (v3 unified-UX refactor).
// Four stepped signal bars in a rounded navy tile; opacity rises 0.55→1.0
// left-to-right. Pure inline SVG, no asset dependency. Faithful port of the
// design-system component (components/brand/PulseMark.jsx).
import React from 'react';
import { v3 } from '../../lib/styleTokens';

export function PulseMark({ size = 28, invert = false, style = {} }) {
  const tileBg = invert ? '#FFFFFF' : v3.color.navy;
  const barFill = invert ? v3.color.navy : '#FFFFFF';
  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: size,
        height: size,
        borderRadius: v3.radius.tile,
        background: tileBg,
        padding: size * 0.11,
        boxSizing: 'border-box',
        flex: '0 0 auto',
        ...style,
      }}
    >
      <svg viewBox="0 0 64 64" width="100%" height="100%" style={{ display: 'block' }}>
        <rect x="6" y="38" width="9" height="20" rx="2" fill={barFill} opacity="0.55" />
        <rect x="19" y="30" width="9" height="28" rx="2" fill={barFill} opacity="0.70" />
        <rect x="32" y="22" width="9" height="36" rx="2" fill={barFill} opacity="0.85" />
        <rect x="45" y="14" width="9" height="44" rx="2" fill={barFill} />
      </svg>
    </span>
  );
}
